import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import ChatMessage from '../components/ChatMessage';
import './MonitorChat.css';
import '../components/ChatMessage.css';

const MonitorChat = () => {
  const { chatId } = useParams();
  const [messages, setMessages] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!chatId) return;

    const loadMessages = async () => {
      if (chatId.startsWith('restaurant_driver_')) {
        // محادثة فردية بين مطعم وسائق
        setTitle(`محادثة بين مطعم وسائق`);
        const q = query(
          collection(db, `chats/${chatId}/messages`),
          orderBy('timestamp', 'asc')
        );
        onSnapshot(q, snapshot => {
          const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setMessages(msgs);
        });

      } else if (chatId.startsWith('restaurant_')) {
        // كل المحادثات المرتبطة بمطعم معين
        const restaurantId = chatId.replace('restaurant_', '');
        setTitle(`كل محادثات المطعم: ${restaurantId}`);
        const allMessages = [];

        const chatsSnapshot = await getDocs(collection(db, 'chats'));
        const restaurantChats = chatsSnapshot.docs.filter(doc =>
          doc.id.startsWith(`restaurant_driver_${restaurantId}_`)
        );

        for (const chat of restaurantChats) {
          const msgsSnapshot = await getDocs(
            query(collection(db, `chats/${chat.id}/messages`), orderBy('timestamp', 'asc'))
          );
          msgsSnapshot.forEach(doc =>
            allMessages.push({ id: doc.id, ...doc.data() })
          );
        }

        setMessages(allMessages);

      } else if (chatId.startsWith('driver_')) {
        // كل المحادثات المرتبطة بسائق معين
        const driverId = chatId.replace('driver_', '');
        setTitle(`كل محادثات السائق: ${driverId}`);
        const allMessages = [];

        const chatsSnapshot = await getDocs(collection(db, 'chats'));
        const driverChats = chatsSnapshot.docs.filter(doc =>
          doc.id.startsWith(`restaurant_driver_`) && doc.id.endsWith(`_${driverId}`)
        );

        for (const chat of driverChats) {
          const msgsSnapshot = await getDocs(
            query(collection(db, `chats/${chat.id}/messages`), orderBy('timestamp', 'asc'))
          );
          msgsSnapshot.forEach(doc =>
            allMessages.push({ id: doc.id, ...doc.data() })
          );
        }

        setMessages(allMessages);
      }
    };

    loadMessages();
  }, [chatId]);

  return (
    <div className="admin-page">
      <AdminSidebar />
      <div className="monitor-chat-content">
        <h2>📂 {title}</h2>
        <div className="chat-box">
          {messages.length === 0 ? (
            <p className="no-messages">لا توجد رسائل حالياً</p>
          ) : (
            messages.map(msg => {
              const senderType = msg.sender || (msg.senderName?.includes('مطعم') ? 'restaurant' : msg.senderName?.includes('سائق') ? 'driver' : 'admin');
              let bubbleClass = 'chat-bubble';
              let icon = '👤';
              if (senderType === 'restaurant') { bubbleClass += ' restaurant'; icon = '🍽️'; }
              else if (senderType === 'driver') { bubbleClass += ' driver'; icon = '🚗'; }
              else if (senderType === 'admin') { bubbleClass += ' admin'; icon = '🛡️'; }
              return (
                <div key={msg.id} className={bubbleClass}>
                  <div className="sender-info">
                    <span className="sender-icon">{icon}</span>
                    <span className="sender-name">{msg.senderName || senderType}</span>
                  </div>
                  <div className="message-content">{msg.message}</div>
                  <div className="message-time">{msg.timestamp?.toDate ? new Date(msg.timestamp.toDate()).toLocaleString() : ''}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default MonitorChat;
